// Centralized site data - Star Otogaz / İnci Akü
export const BRAND = {
  name: "Star Otogaz",
  fullName: "Star Otogaz – İnci Akü Yetkili Bayi",
  slogan: "Güvenli Sürüş, Maksimum Performans",
  phone: "0542 665 26 26",
  phoneTel: "+905426652626",
  phoneRaw: "905426652626",
  address: "Esentepe Mahallesi Eğitimciler Caddesi No:44/B 26210 Tepebaşı / Eskişehir",
  whatsapp: "https://wa.me/905426652626",
  whatsappMessage: "Merhaba, Star Otogaz hakkında bilgi almak istiyorum.",
  email: "info@starotogaz.com",
  logo: "https://customer-assets.emergentagent.com/job_e56c8a7c-9501-4d86-8ace-0c0a2f98ddcb/artifacts/f31zi9id_lOGO.png",
  mapsEmbed:
    "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d12261.986910988271!2d30.493768236874253!3d39.795848325423705!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x14cc15eced076a05%3A0x31396706a42f1e6a!2sStar%20Otogaz%20-%20%C4%B0nci%20Ak%C3%BC%20bayi!5e0!3m2!1str!2str!4v1782040305939!5m2!1str!2str",
  workingHours: "Pzt - Cmt: 09:00 – 19:00",
  social: {
    instagram: "https://instagram.com",
    facebook: "https://facebook.com",
    youtube: "https://youtube.com",
  },
};

export const buildWhatsAppLink = (text) => {
  const msg = text || BRAND.whatsappMessage;
  return `https://wa.me/${BRAND.phoneRaw}?text=${encodeURIComponent(msg)}`;
};

export const NAV_LINKS = [
  { label: "Ana Sayfa", to: "/" },
  { label: "Hakkımızda", to: "/hakkimizda" },
  { label: "Hizmetlerimiz", to: "/hizmetlerimiz" },
  { label: "İnci Akü", to: "/inci-aku" },
  { label: "Galeri", to: "/galeri" },
  { label: "İletişim", to: "/iletisim" },
];

export const SERVICES = [
  {
    slug: "lpg-sistemleri-montaji",
    title: "LPG Sistemleri Montajı",
    icon: "Flame",
    short: "TSE onaylı, sertifikalı LPG dönüşüm uygulamaları.",
    long:
      "Aracınıza özel seçilen marka ve kit ile sertifikalı LPG montajı. Sıralı sistem, 5. nesil ve enjeksiyonlu sistemlerde tam uyumlu kurulum.",
    bullets: [
      "Marka bağımsız montaj",
      "TSE & TÜV standartları",
      "2 yıl montaj garantisi",
    ],
  },
  {
    slug: "bilgisayarli-lpg-ayari",
    title: "Bilgisayarlı LPG Ayarı",
    icon: "Cpu",
    short: "Diagnostik cihazlar ile hassas yakıt haritası ayarı.",
    long:
      "OBD ve ECU üzerinden bilgisayarlı analiz; çekiş kaybı, sarsıntı ve yüksek tüketim sorunları kalibre edilir.",
    bullets: [
      "Lambda & MAP analizi",
      "Tüketim optimizasyonu",
      "Hata kodu temizleme",
    ],
  },
  {
    slug: "sirali-sistem-lpg-servisi",
    title: "Sıralı Sistem LPG Servisi",
    icon: "Layers",
    short: "5. nesil enjeksiyonlu sistemler için tam servis.",
    long:
      "Brc, Atiker, Tartarini, Lovato gibi sıralı sistemlerde bakım, enjektör temizliği, filtre ve sensör değişimi.",
    bullets: [
      "Enjektör bakımı",
      "Filtre değişimi",
      "Yazılım güncelleme",
    ],
  },
  {
    slug: "karburatorlu-lpg-servisi",
    title: "Karbüratörlü LPG Servisi",
    icon: "Wrench",
    short: "Klasik karbüratörlü sistemler için uzman servis.",
    long:
      "Karbüratörlü araçlarda LPG sisteminin temizliği, ayarı, regülatör bakımı ve emniyet kontrolü tek elden.",
    bullets: [
      "Regülatör bakımı",
      "Karbüratör ayarı",
      "Sızdırmazlık testi",
    ],
  },
  {
    slug: "lpg-bakim-ariza-tespiti",
    title: "LPG Bakım ve Arıza Tespiti",
    icon: "Stethoscope",
    short: "Periyodik bakım ve hassas arıza teşhisi.",
    long:
      "Her 10.000 km'de bir önerilen periyodik LPG bakımı; sistem ömrünü uzatır, yakıt tasarrufu sağlar.",
    bullets: [
      "Sızıntı kontrolü",
      "Filtre & buji bakımı",
      "Sensör testleri",
    ],
  },
  {
    slug: "inci-aku-satis-montaj",
    title: "İnci Akü Satış ve Montajı",
    icon: "BatteryCharging",
    short: "Yetkili İnci Akü bayisinden orijinal akü.",
    long:
      "Tüm araç markaları için orijinal İnci Akü çeşitleri, ücretsiz montaj ve eski akü değer ödemesi.",
    bullets: [
      "Orijinal İnci Akü garantisi",
      "Ücretsiz yerinde montaj",
      "Eski akü değer ödeme",
    ],
  },
  {
    slug: "aku-test-kontrol-hizmeti",
    title: "Akü Test ve Kontrol Hizmeti",
    icon: "Activity",
    short: "Şarj, voltaj ve CCA değerleri profesyonel ölçüm.",
    long:
      "Modern test cihazı ile akünüzün gerçek performansı saniyeler içinde raporlanır. Soğuk hava performans testi dahil.",
    bullets: [
      "Ücretsiz test",
      "CCA / iç direnç ölçümü",
      "Şarj sistemi kontrolü",
    ],
  },
  {
    slug: "yag-bakim-servisi",
    title: "Yağ Bakım Servisi",
    icon: "Droplet",
    short: "Orijinal motor yağı, filtre ve bakım paketi.",
    long:
      "Motor yağı, yağ filtresi, hava ve polen filtresi değişimleri; üretici uyumlu doğru spesifikasyonla.",
    bullets: [
      "Orijinal yağ markaları",
      "Tüm filtreler",
      "10 dakikada teslim",
    ],
  },
  {
    slug: "periyodik-arac-bakimi",
    title: "Periyodik Araç Bakımı",
    icon: "Settings2",
    short: "Aracınızın sağlığı için tam bakım protokolü.",
    long:
      "Üretici takvimine uygun 30 noktalı genel bakım kontrolü; balata, fren, kayış ve hortum incelemesi.",
    bullets: [
      "30 noktalı kontrol",
      "Üretici takvimine uygun",
      "Detaylı bakım raporu",
    ],
  },
  {
    slug: "motor-mekanik-tamir-servisi",
    title: "Motor Mekanik Tamir Servisi",
    icon: "Cog",
    short: "Motor revizyon, sızdırmazlık ve mekanik arıza çözümü.",
    long:
      "Motor revizyonu, conta yenileme, triger seti değişimi, kompresyon testi, su pompası, devirdaim ve mekanik aksam onarımları uzman ekibimiz tarafından yapılır.",
    bullets: [
      "Motor revizyon & üst kapak",
      "Triger seti & su pompası",
      "Kompresyon testi",
    ],
  },
];

export const WHY_US = [
  {
    icon: "ShieldCheck",
    title: "Yetkili İnci Akü Bayisi",
    text: "Orijinal ürün, orijinal garanti. Sahte aküye karşı tam güvence.",
  },
  {
    icon: "Award",
    title: "40+ Yıl Tecrübe",
    text: "Eskişehir'de on binlerce araca dokunmuş uzman ekip.",
  },
  {
    icon: "Cpu",
    title: "Modern Diagnostik",
    text: "Bilgisayarlı LPG ayarı ve dijital akü test cihazları.",
  },
  {
    icon: "Clock",
    title: "Hızlı Servis",
    text: "Akü değişimi 10 dakika, LPG bakımı aynı gün teslim.",
  },
  {
    icon: "BadgeCheck",
    title: "Yazılı Garanti",
    text: "Tüm montaj ve servis işlemlerinde yazılı garanti.",
  },
  {
    icon: "HeartHandshake",
    title: "Şeffaf Fiyatlandırma",
    text: "Sürpriz ücret yok. İşlem öncesi net fiyat teklifi.",
  },
];

export const TESTIMONIALS = [
  {
    name: "Mehmet Y.",
    role: "Renault Clio sahibi",
    rating: 5,
    text:
      "Sıralı LPG montajını Star Otogaz'a yaptırdım. Hem temiz işçilik hem de bilgisayarlı ayar sayesinde aracım LPG'de de benzin gibi çalışıyor. Tavsiye ederim.",
  },
  {
    name: "Ayşe K.",
    role: "Ford Focus sahibi",
    rating: 5,
    text:
      "Soğuk sabah aracım çalışmıyordu. İnci Akü yetkili bayi olduklarını öğrendim, aynı gün geldim 10 dakikada yenisi takıldı, eski aküme de iyi fiyat verdiler.",
  },
  {
    name: "Burak D.",
    role: "Fiat Egea sahibi",
    rating: 5,
    text:
      "Bilgisayarlı LPG ayarı sonrası tüketimim ciddi düştü, gaz sarsıntısı tamamen bitti. Profesyonel ve ilgili bir ekip.",
  },
  {
    name: "Selma A.",
    role: "Volkswagen Polo sahibi",
    rating: 5,
    text:
      "Eskişehir'de bu kadar düzenli ve temiz bir oto servis bulmak zor. Yağ bakımı sırasında her şeyi açık şekilde anlattılar.",
  },
  {
    name: "Hasan B.",
    role: "Opel Astra sahibi",
    rating: 5,
    text:
      "Yıllardır aynı yere gidiyorum. Güven veren, dürüst bir esnaf. İnci Akü konusunda da en doğru adres.",
  },
];

export const FAQS = [
  {
    q: "LPG montajı kaç günde tamamlanır?",
    a: "Standart bir sıralı sistem LPG montajı genellikle 1-2 iş gününde tamamlanır. Araç modeline ve seçilen ekipmana göre süre değişebilir.",
  },
  {
    q: "İnci Akü kaç yıl garantilidir?",
    a: "İnci Akü modellerinin garantisi seriye göre değişmekle birlikte genellikle 24 ay üretici garantisi sunulmaktadır. Detaylar için bizi arayabilirsiniz.",
  },
  {
    q: "Akü testiniz ücretli mi?",
    a: "Hayır. Servisimizde akü test ve şarj sistemi kontrolü tamamen ücretsizdir. Bilgisayarlı dijital cihazlarla saniyeler içinde rapor alabilirsiniz.",
  },
  {
    q: "LPG'li araçta periyodik bakım gerekir mi?",
    a: "Evet. LPG sistemleri, sistem ömrü ve güvenliği için her 10.000 km'de bir profesyonel bakım gerektirir. Filtre ve enjektör temizliği bu süreçte yapılır.",
  },
  {
    q: "Aküde sigorta veya kasko hasarı kabul ediyor musunuz?",
    a: "Evet. Anlaşmalı olduğumuz sigorta firmaları için akü ve montaj faturalandırması yapabiliyoruz.",
  },
  {
    q: "Hangi LPG markalarına servis veriyorsunuz?",
    a: "Brc, Atiker, Tartarini, Lovato, Voltran, Aygaz Otogaz başta olmak üzere tüm bilinen marka LPG sistemlerine montaj ve servis veriyoruz.",
  },
];

export const CAMPAIGNS = [
  {
    badge: "Sınırlı Süreli",
    title: "İnci Akü'de Eski Akü Değer Ödeme",
    text: "Eski akünüzü getirin, yeni İnci Akü alımınızda en yüksek değer ödemesini bizden alın.",
    cta: "Hemen Sor",
    accent: "blue",
  },
  {
    badge: "Yeni Kampanya",
    title: "LPG Montaj + 1 Yıl Ücretsiz Bakım",
    text: "Bu ay sıralı LPG montajı yaptıran müşterilerimize 12 ay ücretsiz periyodik LPG bakımı.",
    cta: "Teklif Al",
    accent: "gold",
  },
  {
    badge: "Sezon Özel",
    title: "Kış Bakım Paketi",
    text: "Akü testi + antifriz kontrolü + yağ bakımı tek pakette indirimli fiyatla.",
    cta: "Detaylar",
    accent: "gold",
  },
];

export const STATS = [
  { value: "40+", label: "Yıl Tecrübe" },
  { value: "10K+", label: "Mutlu Müşteri" },
  { value: "5K+", label: "LPG Montajı" },
  { value: "24/7", label: "Destek Hattı" },
];

// Curated stock images
export const IMAGES = {
  hero: "https://images.pexels.com/photos/9139588/pexels-photo-9139588.jpeg",
  about: "https://images.unsplash.com/photo-1615906655593-ad0386982a0f?auto=format&fit=crop&w=1600&q=80",
  battery: "https://images.unsplash.com/photo-1632733711679-529326f6db12?auto=format&fit=crop&w=1600&q=80",
  workshop: "https://images.unsplash.com/photo-1486262715619-67b85e0b08d3?auto=format&fit=crop&w=1600&q=80",
  lpg: "https://images.unsplash.com/photo-1632823469850-1b7b1e8b7e3f?auto=format&fit=crop&w=1600&q=80",
  gallery: [
    {
      src: "https://images.unsplash.com/photo-1486262715619-67b85e0b08d3?auto=format&fit=crop&w=1400&q=80",
      caption: "Atölyemizden bir kare",
      span: "row-span-2",
    },
    {
      src: "https://images.unsplash.com/photo-1632733711679-529326f6db12?auto=format&fit=crop&w=1400&q=80",
      caption: "Orijinal İnci Akü stoklarımız",
    },
    {
      src: "https://images.unsplash.com/photo-1605152276897-4f618f831968?auto=format&fit=crop&w=1400&q=80",
      caption: "Bilgisayarlı LPG ayarı",
    },
    {
      src: "https://images.pexels.com/photos/4489732/pexels-photo-4489732.jpeg?auto=compress&cs=tinysrgb&w=1400",
      caption: "Profesyonel akü kontrolü",
      span: "col-span-2",
    },
    {
      src: "https://images.unsplash.com/photo-1493238792000-8113da705763?auto=format&fit=crop&w=1400&q=80",
      caption: "Detaylı motor bakımı",
    },
    {
      src: "https://images.unsplash.com/photo-1530046339915-78e95cb1a8f7?auto=format&fit=crop&w=1400&q=80",
      caption: "Motor odası genel görünüm",
    },
    {
      src: "https://images.unsplash.com/photo-1597007030739-6d2e7172ee6c?auto=format&fit=crop&w=1400&q=80",
      caption: "Yağ ve filtre bakım servisi",
      span: "col-span-2",
    },
    {
      src: "https://images.unsplash.com/photo-1632823471565-1ec1a3f31a48?auto=format&fit=crop&w=1400&q=80",
      caption: "Akü değişim öncesi inceleme",
    },
  ],
};

export const BATTERY_BRANDS = [
  {
    name: "İnci Akü",
    product: "https://customer-assets.emergentagent.com/job_inci-aku-bayi-demo/artifacts/siysvrsh_110000684180635.jpg",
    color: "#0046AD",
    tagline: "Yetkili Bayi",
  },
  {
    name: "Varta",
    product: "https://customer-assets.emergentagent.com/job_inci-aku-bayi-demo/artifacts/fisyv7gg_images.jpg",
    color: "#1E3A8A",
    tagline: "Premium Akü",
  },
  {
    name: "Bosch",
    product: "https://customer-assets.emergentagent.com/job_inci-aku-bayi-demo/artifacts/u8108wg9_10644507983922.jpg",
    color: "#ED1C24",
    tagline: "Alman Mühendisliği",
  },
];

export const BATTERY_TYPES = [
  {
    title: "İnci Maxim A Serisi",
    desc: "Yüksek performanslı binek araç aküleri. Uzun ömür, güçlü ilk hareket.",
    feature: "60Ah – 100Ah",
  },
  {
    title: "İnci Maxim Asia",
    desc: "Asya tipi araçlar için ideal, ince kutuplu modeller.",
    feature: "45Ah – 75Ah",
  },
  {
    title: "İnci Formul A EFB",
    desc: "Start-Stop sistemli modern araçlar için EFB teknolojisi.",
    feature: "60Ah – 95Ah EFB",
  },
  {
    title: "İnci Formul A AGM",
    desc: "Premium segment, ileri Start-Stop ve hibrit araçlara özel AGM.",
    feature: "70Ah – 105Ah AGM",
  },
  {
    title: "İnci Ticari",
    desc: "Kamyon, otobüs ve ticari araçlar için yüksek kapasite seçenekleri.",
    feature: "100Ah – 230Ah",
  },
  {
    title: "İnci Marin & Tarım",
    desc: "Deniz araçları, traktör ve iş makineleri için dayanıklı seri.",
    feature: "Özel kapasiteler",
  },
];
